/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-16 08:34:34
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Popover } from '@shopify/polaris';
import validateColor from 'validate-color';

import { RenderColorPicker2 } from 'src/components/views/common/forms/render-color-picker-2';

type Props = {
  colorValue: string,
  fieldName: string,
  fieldLabel: string,
  disabled?: boolean,
  updateField: (fieldName: string, color: Object) => void
};

type State = {
  hexColor: string,
  activeColorPicker: boolean
};
class RenderColorPickerPopover extends Component<Props, State> {
  state = {
    hexColor: '#FFFFFF',
    activeColorPicker: false
  };

  componentDidMount() {
    const { colorValue } = this.props;
    // Calculate hex color
    this.setState({ hexColor: colorValue });
  }

  componentWillReceiveProps(nextProps: Props) {
    const { colorValue } = nextProps;
    const { hexColor } = this.state;

    // Calculate hex color when change color from parent
    if (colorValue !== hexColor) {
      this.setState({ hexColor: colorValue });
    }
  }

  render() {
    const { activeColorPicker, hexColor } = this.state;
    const { fieldName, fieldLabel, disabled = false } = this.props;

    const activator = (
      <div className="colorPickerBox">
        <div className="Polaris-Labelled__LabelWrapper">
          <div className="Polaris-Label">
            <label className="Polaris-Label__Text" style={{ display: 'inline-flex' }}>
              {fieldLabel}
            </label>
          </div>
        </div>
        <div className={`Polaris-TextField ${disabled ? 'Polaris-TextField--disabled' : ''}`}>
          <div
            className="Polaris-ResourceList__Badge selectedColor"
            style={{ backgroundColor: hexColor }}
            onClick={!disabled ? this.handleOpenColorPicker : void 0}></div>
          <input
            id={`${fieldName}_ColorPicker`}
            type="text"
            className="Polaris-TextField__Input"
            value={hexColor.includes('#') ? hexColor.toUpperCase() : hexColor}
            onClick={this.handleOpenColorPicker}
            onChange={this.onInputColorValue}
            onBlur={this.onBlurValue}
            disabled={disabled}
          />
          <div className="Polaris-TextField__Backdrop"></div>
        </div>
      </div>
    );

    return (
      <Popover
        active={activeColorPicker}
        activator={activator}
        onClose={this.handleOpenColorPicker}
        preferredAlignment="left">
        <Field
          name={fieldName}
          component={RenderColorPicker2}
          color={hexColor}
          onChange={this.handleChangeColor}
          normalize={color => (color.hex ? color.hex.toUpperCase() : '')}
        />
      </Popover>
    );
  }

  handleOpenColorPicker = () => {
    this.setState(({ activeColorPicker }) => ({
      activeColorPicker: !activeColorPicker
    }));
  };

  handleChangeColor = (color: Object) => {
    const { hex: hexColor } = color;
    this.setState({ hexColor });
  };

  onInputColorValue = (e: any) => {
    const { hexColor: hexColorPrev } = this.state;
    const { updateField, fieldName } = this.props;
    let input = e.target.value;
    const hexColor = !_.isEmpty(input) ? input : hexColorPrev;

    this.setState({ hexColor });

    // update color on redux-form
    updateField(fieldName, hexColor);
  };

  // Validate after enter value
  onBlurValue = (e: any) => {
    let { hexColor } = this.state;
    const color = hexColor;

    if (!validateColor(color)) {
      const { updateField, fieldName } = this.props;

      hexColor = '#FFFFFF';

      this.setState({ hexColor });

      // update color on redux-form
      updateField(fieldName, hexColor);
    }
  };
}

export default RenderColorPickerPopover;
